import { render } from "./OrderCommentSection.vue?vue&type=template&id=5cc9e093"
import script from "./OrderCommentSection.vue?vue&type=script&lang=js"
export * from "./OrderCommentSection.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_955269ba/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__